module.exports = new __parcel__URL__("empty-no-search-results-v2-darkmode.fad57704.svg").toString();